export default [
  {
    path: '/reports/usage-analytics',
    name: 'usage-analytics',
    meta: {
      title: 'Usage Analytics',
      authRequired: true,
      privileges: ['VIEW_USAGE_ANALYTICS', 'AUDIT_USAGE_ANALYTICS'],
    },
    component: () => import('../views/reports/usage-analytics.vue'),
  },
]
